import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import CTO from "../cto/CTO";
import Settlemet from "../settlemet/Settlemet";
import ProfitShare from "../profit-share/ProfitShare";
import { setSelectedTab } from "../../../redux/reducers/tabsSlice";

function TabsPayouts() {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state) => state.tabs.selectedTab);

  const handleTabChange = (selectedTabKey) => {
    dispatch(setSelectedTab(selectedTabKey));
  };

  return (
    <div className="tabsPayoutsContainer">
      <Tabs
        activeKey={selectedTab}
        id="uncontrolled-payouts-tab"
        className=""
        onSelect={handleTabChange}
      >
        <Tab eventKey="settlement" title="Settlement">
          <Settlemet />
        </Tab>
        <Tab eventKey="cto" title="CTO">
          <CTO />
        </Tab>
        <Tab eventKey="profit-share" title="Profit Share">
          <ProfitShare />
        </Tab>
      </Tabs>
    </div>
  );
}

export default TabsPayouts;
